// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"884ee527","295":"ce7686bd","687":"ce7686bd","747":"d4755cd9","787":"37774e10"}[chunkId] + ".chunk.css";
};